import Dexie from 'dexie';

export const db = new Dexie('MembersgramDB');
db.version(1).stores({
  Data: '++id, Email,PhoneNumber,Picture' 
});